import { SystemProductSelectPtBr } from "./system-product-select-pt-br";

export const SYSTEM_PRODUCT_SELECT_EN_US: SystemProductSelectPtBr = {
	label: "System product",
	placeholder: "Select a system product",
	auxiliarSheet: {
		systemProducts: "System Products",
		systemProductName: "Name",
		systemProductSk: "SK",
		systemProductId: "ID",
	},
};
